import React from "react";
import { MdLocationOn } from "react-icons/md";
import "./CenterCard.css";

const CenterCard = ({ center }) => {
  const handleGetDirections = () => {
    if (center?.center_URL) {
      window.open(center.center_URL, "_blank");
    }
  };

  return (
    <div className="center-card">
      <h3 className="center-name">{center?.center_name || "Center Name"}</h3>

      <p className="center-address">
        {center?.center_address || "Address not available"}
      </p>

      <button
        className="rbdButton get-directions-btn"
        onClick={handleGetDirections}
        disabled={!center?.center_URL}
      > <span className="btn-text">
          <MdLocationOn size={16} />
          Get Directions
        </span>
      </button>
    </div>
  );
};

export default CenterCard;
